module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-7-1500x630.92c5caa0.jpg";